/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApplicationOrdersGetOrderResponse { 
    id?: number;
    customerId?: string | null;
    customerName?: string | null;
    subject?: string | null;
    status?: string | null;
    date?: string;
    amount?: number;
    userId?: string | null;
    salesRepresentativeName?: string | null;
}

